import { ReportColumnConfig } from "components/ReportGrid_New/types";

export const rootChartContainerId = 'chart-container';

export const COVEA_REPORT_TITLE = 'Repair Status Portal Usage V1';

export const COVEA_REPORT_MESSAGE = 'Shows the repair status portal usage.';

export const COVEA_REPORT_GRID_TITLE = 'RepairStatusPortalUsage';

export const columns: ReportColumnConfig[] = [
  { name: 'repairCode', title: 'Repair Code' },
  { name: 'repairer', title: 'Repairer Name' },
  { name: 'regmark', title: 'Vehicle Reg' },
  { name: 'claimReference', title: 'Claim Reference' },
  { name: 'onSiteDate', title: 'On Site Date', type: 'date' },
  { name: 'smsSentDate', title: 'SMS Sent Date', type: 'date' },
  { name: 'termsAcceptedDate', title: 'Terms Accepted Date' },
  { name: 'numberOfHits', title: 'Number of Hits' },
];
